import { render, staticRenderFns } from "./supplier-map.vue?vue&type=template&id=518ffe24"
import script from "./supplier-map.vue?vue&type=script&lang=js"
export * from "./supplier-map.vue?vue&type=script&lang=js"
import style0 from "./supplier-map.vue?vue&type=style&index=0&id=518ffe24&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518ffe24')) {
      api.createRecord('518ffe24', component.options)
    } else {
      api.reload('518ffe24', component.options)
    }
    module.hot.accept("./supplier-map.vue?vue&type=template&id=518ffe24", function () {
      api.rerender('518ffe24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/map/supplier-map.vue"
export default component.exports